import FastFacts from "./tabs/FastFacts"
import TopUniversities from "./tabs/TopUniversities"
import Admissions from "./tabs/Admissions"
import Scholarships from "./tabs/Scholarships"
import Visa from "./tabs/Visa"
import CostOfLiving from "./tabs/CostOfLiving"
import WorkOpportunities from "./tabs/WorkOpportunities"
import Faqs from "./tabs/Faqs"
import "./TabContent.css"

const TabContent = ({ activeTab, countryData }) => {
  // Render the appropriate component based on the active tab
  const renderTabContent = () => {
    switch (activeTab) {
      case "FAST FACTS":
        return <FastFacts countryData={countryData} />
      case "TOP UNIVERSITIES":
        return <TopUniversities countryData={countryData} />
      case "ADMISSIONS":
        return <Admissions countryData={countryData} />
      case "SCHOLARSHIPS":
        return <Scholarships countryData={countryData} />
      case "VISA":
        return <Visa countryData={countryData} />
      case "COST OF LIVING":
        return <CostOfLiving countryData={countryData} />
      case "WORK OPPORTUNITIES":
        return <WorkOpportunities countryData={countryData} />
      case "FAQS":
        return <Faqs countryData={countryData} />
      default:
        return <FastFacts countryData={countryData} />
    }
  }

  return <div className="tab-content-container">{renderTabContent()}</div>
}

export default TabContent
